import { css } from '@emotion/react';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { useState, useRef, ReactNode } from 'react';

const initialOpen = false;

interface IProps {
  summary: ReactNode;
  contentPlaceholder: ReactNode;
  renderContent: () => ReactNode;
}

export default function ExpandableDetails({
  summary,
  contentPlaceholder,
  renderContent,
}: IProps) {
  const [open, setOpen] = useState(initialOpen);

  const ref = useRef<HTMLDetailsElement>(null);

  const toggle = () => {
    const nextOpen = !open;

    setOpen(nextOpen);

    if (ref.current) {
      ref.current.open = nextOpen;
    }
  };

  return (
    <Typography
      component="div"
      variant="body1"
      css={css`
        display: flex;
        align-items: flex-start;

        svg {
          font-size: 20px;
        }

        details {
          flex-grow: 1;
        }
        details summary::-webkit-details-marker {
          display: none;
        }
        details summary {
          padding: 8px;
          margin: 3px;
          padding-left: 4px;
          margin-left: -4px;

          letter-spacing: 0.5px;

          cursor: pointer;
        }
      `}
    >
      <IconButton
        onClick={toggle}
        aria-hidden={true /* This button is just visual extra */}
      >
        {open ? <RemoveIcon /> : <AddIcon />}
      </IconButton>
      <details
        ref={ref}
        open={initialOpen}
        onToggle={(event) => {
          setOpen(event.currentTarget.open);
        }}
      >
        <summary>{summary}</summary>
        {open ? renderContent() : contentPlaceholder}
      </details>
    </Typography>
  );
}
